export default __webpack_public_path__ + "static/media/sun.ccdc167f.png";